export const parseSpeaker = (input) => {
    const speaker = {
        firstName: '',
        lastName: '',
        role: '',
    };
    let fullName = input;
    const roleStart = input.indexOf('(');
    const roleEnd = input.lastIndexOf(')');
    if (roleStart !== -1 && roleEnd > roleStart) {
        speaker.role = input.slice(roleStart + 1, roleEnd);
        fullName = input.slice(0, roleStart).trim();
    }
    if (fullName.match(/ /)) {
        speaker.firstName = fullName.replace(/(.*) .*/, '$1');
        speaker.lastName = fullName.replace(/.* (.*)/, '$1');
    }
    else {
        speaker.firstName = fullName;
    }
    return speaker;
};
